import { VFC } from 'react'

interface MANIPULATIONPANELPROPS {
    onChange: (event: string) => void;
}

export const ManipulationPanel: VFC<MANIPULATIONPANELPROPS> = ({ onChange }) => {
    const onManipulationUp = () => onChange('up');
    const onManipulationRight = () => onChange('right');
    const onManipulationLeft = () => onChange('left');
    const onManipulationDown = () => onChange('down');
    return (
        <>
            <div>
                <button onClick={ onManipulationRight }>←</button>
                <button onClick={ onManipulationUp }>↑</button>
                <button onClick={ onManipulationDown }>↓</button>
                <button onClick={ onManipulationLeft }>→</button>
            </div>
        </>
    );
}